import React from 'react';

 class UploadButtonRenderer extends React.Component {
    constructor(props) {
        super(props);
        this.btnClickedHandler = this.btnClickedHandler.bind(this);
      }
      btnClickedHandler=()=> {
        this.props.clicked(this.props.data.ticketId);
       }
      render() {
        return (
            <button class="btn btn-primary smalluploadbutton btn-sm" onClick={this.btnClickedHandler}>Upload</button>                
        )
      }
    }
    export default UploadButtonRenderer;